import { useDispatch } from "react-redux";
import {
  prevStep,
  updateField,
} from "../../../store/reducers/users/usersForm.slice";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  getEscuelasThunk,
  getPlantelesThunk,
} from "../../../store/reducers/users/users.thunks";

const StepInstitution = ({ submit }) => {
  const dispatch = useDispatch();

  const { escuelas, planteles } = useSelector((state) => state.users);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });

  // Cargar escuelas al montar
  useEffect(() => {
    dispatch(getEscuelasThunk());
  }, [dispatch]);

  // 🔹 Cuando cambia escuela
  const handleEscuelaChange = (e) => {
    const escuelaId = Number(e.target.value);

    setValue("escuela", escuelaId, { shouldValidate: true });
    setValue("plantel", "", { shouldValidate: true });

    if (escuelaId) {
      dispatch(getPlantelesThunk(escuelaId));
    }
  };

  // 🔹 Submit final
  const onSubmit = (data) => {
    Object.entries(data).forEach(([name, value]) => {
      dispatch(updateField({ name, value: Number(value) || value }));
    });

    submit();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    dispatch(
      updateField({
        name,
        value: ["plantel", "escuela"].includes(name) ? Number(value) : value,
      }),
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="vstack gap-3">
      <div className="vstack gap-3">
        <div className="form-floating">
          <select
            className={`form-select ${errors.escuela ? "is-invalid" : ""}`}
            defaultValue=""
            {...register("escuela", { required: "La escuela es obligatoria" })}
            onChange={handleEscuelaChange}
          >
            <option value="" disabled>
              Selecciona una escuela
            </option>

            {escuelas.map((e) => (
              <option key={e.id} value={e.id}>
                {e.label}
              </option>
            ))}
          </select>
          <label>Escuela</label>

          {errors.escuela && (
            <div className="invalid-feedback">{errors.escuela.message}</div>
          )}
        </div>

        {/* Plantel */}
        <div className="form-floating">
          <select
            className={`form-select ${errors.plantel ? "is-invalid" : ""}`}
            defaultValue=""
            {...register("plantel", {
              required: "El plantel es obligatorio",
            })}
            disabled={!planteles.length}
          >
            <option value="" disabled>
              Selecciona un plantel
            </option>

            {planteles.map((p) => (
              <option key={p.id} value={p.id}>
                {p.label}
              </option>
            ))}
          </select>

          <label>Plantel</label>

          {errors.plantel && (
            <div className="invalid-feedback">{errors.plantel.message}</div>
          )}
        </div>

        <div className="form-floating">
          <input
            className="form-control"
            name="curp"
            placeholder="CURP"
            onChange={handleChange}
          />
          <label>CURP</label>
        </div>

        <div className="form-floating">
          <input
            className="form-control"
            name="rfc"
            placeholder="RFC"
            onChange={handleChange}
          />
          <label>RFC</label>
        </div>

        <div className="d-flex justify-content-between">
          <button
            className="btn btn-outline-secondary"
            onClick={() => dispatch(prevStep())}
          >
            Atrás
          </button>

          <button type="submit" className="btn btn-primary" disabled={!isValid}>
            Guardar usuario
          </button>
        </div>
      </div>
    </form>
  );
};

export default StepInstitution;
